import axios from "axios";
import { TICKETS_URL } from "../../API/Api";

const GetAllTicketsMethod = async (data) => {
    let headers = {
        Accept: "application/json",
    };

    let response = await axios({
        method: "GET",
        baseURL: `${TICKETS_URL}`,
        headers: headers,
        params: {...data}
    });
    return response.data;
};

const GetSingleTicketsMethod = async (ticket_id) => {
    let headers = {
        Accept: "application/json",
    };

    let response = await axios({
        method: "GET",
        baseURL: `${TICKETS_URL}/show-single-ticket/${ticket_id}`,
        headers: headers,
    });
    return response.data;
};
const TicketsService = {
    GetAllTicketsMethod,
    GetSingleTicketsMethod
};

export default TicketsService;
